<template>
  <div>
    <el-card>
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <span class="group-title">No：{{ formData.custNo }}</span>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <span class="group-title">Status：{{ formData.custStatusText }}</span>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <span class="group-title"
            >Create：{{ formData.createByName }} at
            {{ formData.createDate }}</span
          >
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <span class="group-title"
            >Modify：{{ formData.modifyByName }} at
            {{ formData.modifyDate }}</span
          >
        </el-col>
      </el-row>
      <div class="d2-mt">
        <el-form ref="formData" :model="formData" :rules="rules" size="mini">
          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 12 }" :lg="{ span: 12 }">
              <el-form-item label="客户名称" prop="custName">
                <el-input
                  readonly
                  v-model="formData.custName"
                  placeholder=" 请输入..."
                  maxlength="200"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label="客户类型" prop="customerType">
                <el-input
                  readonly
                  v-model="formData.v_customerType"
                  placeholder=" 请输入..."
                  maxlength="200"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label=" 门店类型" prop="storeType">
                <el-input
                  readonly
                  v-model="formData.v_storeType"
                  placeholder=" 请输入..."
                  maxlength="200"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label="客户定义" prop="customerDefinition">
                <el-input
                  readonly
                  v-model="formData.v_customerDefinition"
                  placeholder=" 请输入..."
                  maxlength="200"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label="客户基本分类" prop="v_marketRegion">
                <el-input
                  readonly
                  v-model="formData.v_marketRegion"
                  placeholder=" 请输入..."
                  maxlength="200"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 12 }" :lg="{ span: 12 }">
              <el-form-item label=" 详细地址" prop="custAddress">
                <el-input
                  readonly
                  v-model="formData.custAddress"
                  placeholder=" 请输入..."
                  maxlength="500"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label=" 主要联系人" prop="contact">
                <el-input
                  readonly
                  v-model="formData.contact"
                  placeholder=" 请输入..."
                  maxlength="50"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label=" 联系人手机" prop="contactMobile">
                <el-input
                  readonly
                  v-model="formData.contactMobile"
                  placeholder=" 请输入..."
                  maxlength="50"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label="固定电话" prop="contactPhone">
                <el-input
                  readonly
                  v-model="formData.contactPhone"
                  placeholder=" 请输入..."
                  maxlength="50"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label="Email" prop="contactEmail">
                <el-input
                  readonly
                  v-model="formData.contactEmail"
                  placeholder=" 请输入..."
                  maxlength="50"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label="联系人职务" prop="contactJob">
                <el-input
                  readonly
                  v-model="formData.contactJob"
                  placeholder=" 请输入..."
                  maxlength="50"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item label=" 客户品牌">
                <el-input
                  readonly
                  v-model="formData.brandNames"
                  placeholder=" 请输入..."
                  maxlength="50"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 12 }" :lg="{ span: 12 }">
              <el-form-item label="付款条件">
                <el-input
                  readonly
                  v-model="formData.v_paymentTerms"
                  maxlength="200"
                  clearable
                  size="mini"
                  placeholder="请输入..."
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                label="
                  统一社会信用代码
                "
                prop="businessLicense"
              >
                <el-input
                  readonly
                  v-model="formData.businessLicense"
                  placeholder=" 请输入..."
                  maxlength="50"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 18 }" :lg="{ span: 18 }">
              <el-form-item label="消费人群" prop="endCustomers">
                <el-input
                  readonly
                  v-model="formData.endCustomers"
                  maxlength="200"
                  clearable
                  size="mini"
                  placeholder="请输入..."
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="客户产品品类">
                <el-input
                  v-model="formData.custProductCategory"
                  readonly
                  type="textarea"
                  placeholder="请输入..."
                  rows="3"
                  maxlength="500"
                  show-word-limit
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <CustBankTable
              :tableData="formData.masterCustomerBankList"
              ref="custBank"
            />
          </el-row>
        </el-form>
        <div class="d2-mt" v-show="false">
          <!--formData.custCode-->
          <div class="side-frame">
            客户选项
          </div>
          <labels ref="labels" readonly :params="params" />
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import Labels from './labels'
import CustBankTable from './custbankTable.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Labels,
    CustBankTable,
  },
  data() {
    return {
      pageHeader: '',
      params: {
        custCode: '',
      },
      formData: {
        custCode: '',
        custNo: '',
        custName: '',
        regionCode: '100000',
        regionName: '中国',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        custAddress: '',
        contact: '',
        contactMobile: '',
        contactPhone: '',
        contactEmail: '',
        contactJob: '',
        companyCode: '',
        custStatus: '',
        createBy: '',
        createDate: '',
        modifyBy: '',
        modifyDate: '',
        createByName: '',
        modifyByName: '',
        customerType: '',
        storeType: '',
        customerDefinition: '',
        marketRegion: '',
        endCustomers: '',
        businessLicense: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        bankAccountKind: '',
        brandCodeList: [],
        custProductCategory: '',
      },
      rules: {
        custName: [
          {
            required: true,
            message: '请输入客户名称',
            trigger: 'blur',
          },
        ],
        v_customerType: [
          {
            required: true,
            message: '请输入客户类型',
            trigger: 'change',
          },
        ],
        v_marketRegion: [
          {
            required: true,
            message: '请输入客户基本分类',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.params.custCode) {
      this.detailLoad(this.$route.params.custCode)
    }
  },

  methods: {
    ...mapActions('admin/page', ['close']),
    detailLoad(val) {
      this.pageHeader = '客户档案信息详情'
      let param = { custCode: val }
      this.$api.opaCustomerDetailApi(param).then((res) => {
        this.formData = res.body
        this.$refs.labels.load(param)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
.el-form-item {
  margin-bottom: 5px !important;
}
</style>
